import React, { Suspense } from 'react';

const DelayedCatalogFeedSelectionStep =
  React.lazy(() => import(/* webpackChunkName: "catalog-feed-selection-step.async" */ './catalog-feed-selection-step')
    .then(({ CatalogFeedSelectionStepWithI18n }) => ({ default: CatalogFeedSelectionStepWithI18n })));

export const DelayedCatalogFeedSelectionStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedCatalogFeedSelectionStep />
  </Suspense>
);
